module.exports = __webpack_public_path__ + "img/stock7.48a4c0e8.png";